const Login = () => import(/* webpackChunkName: "login" */ "@/views/Login.vue");

export enum LoginRoute {
  LOGIN = "Login",
}

export default [{ component: Login, name: LoginRoute.LOGIN, path: "/login" }];
